/* =========================================================
   Botón Flotante de WhatsApp para Shopify
   ========================================================= */
(function () {
  "use strict";

  // 🔧 CONFIGURACIÓN
  const CONFIG = {
    whatsappLink: "https://wa.link/vu9fxk", // Enlace corto de WhatsApp
    position: "bottom-right",              // "bottom-right" | "bottom-left"
    offsetRight: "20px",                   // Separación del lado derecho
    offsetBottom: "20px",                  // Separación de la parte inferior
    offsetLeft: "20px",                    // Separación del lado izquierdo (si aplica)
    size: "60px",                          // Tamaño del botón
    zIndex: 999999,                        // Siempre por encima de todo
    bgColor: "#25D366",                    // Verde oficial de WhatsApp
    hoverColor: "#128C7E",                 // Verde oscuro al hover
    iconColor: "#FFFFFF",                  // Color del ícono
    pulse: true                            // Animación de pulso
  };

  // Evitar duplicados
  if (document.getElementById("wa-float-btn")) return;

  // ---------- INYECTAR ESTILOS ----------
  const style = document.createElement("style");
  style.id = "wa-float-styles";
  style.textContent = `
    #wa-float-btn {
      position: fixed;
      ${CONFIG.position === "bottom-right" ? `right: ${CONFIG.offsetRight};` : `left: ${CONFIG.offsetLeft};`}
      bottom: ${CONFIG.offsetBottom};
      width: ${CONFIG.size};
      height: ${CONFIG.size};
      background-color: ${CONFIG.bgColor};
      color: ${CONFIG.iconColor};
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
      cursor: pointer;
      z-index: ${CONFIG.zIndex};
      text-decoration: none;
      transition: transform 0.25s ease, background-color 0.25s ease, box-shadow 0.25s ease;
      -webkit-tap-highlight-color: transparent;
    }

    #wa-float-btn:hover {
      background-color: ${CONFIG.hoverColor};
      transform: scale(1.1);
      box-shadow: 0 6px 18px rgba(0, 0, 0, 0.35);
    }

    #wa-float-btn:active {
      transform: scale(0.95);
    }

    #wa-float-btn svg {
      width: 55%;
      height: 55%;
      fill: currentColor;
      pointer-events: none;
    }

    ${CONFIG.pulse ? `
    #wa-float-btn::before {
      content: "";
      position: absolute;
      inset: 0;
      border-radius: 50%;
      background-color: ${CONFIG.bgColor};
      opacity: 0.7;
      z-index: -1;
      animation: wa-pulse 2s infinite;
    }
    @keyframes wa-pulse {
      0%   { transform: scale(1);   opacity: 0.7; }
      70%  { transform: scale(1.6); opacity: 0;   }
      100% { transform: scale(1.6); opacity: 0;   }
    }
    ` : ""}

    /* Móvil: un poco más pequeño */
    @media (max-width: 480px) {
      #wa-float-btn {
        width: 56px;
        height: 56px;
      }
    }
  `;
  document.head.appendChild(style);

  // ---------- CREAR BOTÓN ----------
  const btn = document.createElement("a");
  btn.id = "wa-float-btn";
  btn.href = CONFIG.whatsappLink;          // ✅ Enlace corto directo
  btn.target = "_blank";
  btn.rel = "noopener noreferrer";
  btn.setAttribute("aria-label", "Contactar por WhatsApp");
  btn.title = "Contactar por WhatsApp";

  // SVG de WhatsApp (mismo que enviaste)
  btn.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true">
      <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
    </svg>
  `;

  // ---------- INSERTAR EN EL DOM ----------
  const append = () => document.body.appendChild(btn);
  if (document.body) append();
  else document.addEventListener("DOMContentLoaded", append);
})();